import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Banner, BannerStatus } from "@/services/banner.service.ts";

interface BannerDisplayProps {
  banners: Banner[];
  setIsReordering: React.Dispatch<React.SetStateAction<boolean>>;
}

const BannerDisplay: React.FC<BannerDisplayProps> = ({
  banners,
  setIsReordering,
}) => {
  const showingBanners = banners.filter(
    (banner) => banner.status === BannerStatus.SHOWING,
  );

  return (
    <div>
      <h2 className="text-2xl font-bold text-white">Banner in Showing</h2>
      <div className="mt-2 rounded-xl border-0 bg-[#12122e] px-4 py-4">
        {/* Reorder Button */}
        <div className="flex justify-end">
          <button
            onClick={() => setIsReordering(true)}
            className="rounded-lg border border-[#79BFFF] px-4 py-2 text-[#79BFFF] transition"
          >
            Reorder
          </button>
        </div>

        {/* If banners exist, show Swiper */}
        {showingBanners.length > 0 ? (
          <Swiper spaceBetween={20} slidesPerView={2}>
            {showingBanners.map((banner, index) => (
              <SwiperSlide key={index}>
                <div className="flex flex-col">
                  {banner.desktopUrl ? (
                    <img
                      src={banner.desktopUrl}
                      alt=""
                      className="h-48 w-full rounded-xl"
                    />
                  ) : (
                    <div className="flex h-48 w-full items-center justify-center rounded-xl border border-gray-700 bg-gray-800 text-xl text-gray-400">
                      No image
                    </div>
                  )}
                  <p className="mt-2 text-gray-300">{banner.name}</p>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        ) : (
          /* Show empty state when no banners */
          <div className="flex h-48 w-full items-center justify-center bg-[#12122e] text-xl text-gray-400">
            no banner in showing
          </div>
        )}
      </div>
    </div>
  );
};

export default BannerDisplay;
